import React, { ReactNode } from 'react';

interface INoDataText {
  children: ReactNode;
}

export default ({ children }: INoDataText) => (
  <p className='text-black/50 text-center md:text-2xl'>{children}</p>
);
